<template>
    <!--begin::Menu-->
    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold py-4 fs-6 w-275px"
         data-kt-menu="true"  v-if="user">
        <!--begin::Menu item-->
        <div class="menu-item px-3">
            <div class="menu-content d-flex align-items-center px-3">
                <!--begin::Avatar-->
                <div class="symbol symbol-50px me-5">
                    <img alt="Avatar" src="assets/media/auth/no-avatar.jpg" />
                </div>
                <!--end::Avatar-->
                <!--begin::Username-->
                <div class="d-flex flex-column">
                    <div class="fw-bold d-flex align-items-center fs-5">
                        {{user?.fullName}}
                        <!--<span class="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">Pro</span>-->
                    </div>
                    <a href="#" class="fw-semibold text-muted text-hover-primary fs-7">{{user?.email}}</a>
                </div>
                <!--end::Username-->
            </div>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu separator-->
        <div class="separator my-2"></div>
        <!--end::Menu separator-->
        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
            <router-link to="/pages/profile/overview" class="menu-link px-5">
                My Profile
            </router-link>
        </div>-->
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
            <router-link to="/pages/profile/overview" class="menu-link px-5">
                <span class="menu-text">My Projects</span>
                <span class="menu-badge">
                    <span class="badge badge-light-danger badge-circle fw-bold fs-7">3</span>
                </span>
            </router-link>
        </div>-->
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <!--<div class="menu-item px-5"
             data-kt-menu-trigger="hover"
             data-kt-menu-placement="left-start"
             data-kt-menu-flip="center, top">
            <router-link to="/pages/profile/overview" class="menu-link px-5">
                <span class="menu-title">My Subscription</span>
                <span class="menu-arrow"></span>
            </router-link>-->

            <!--begin::Menu sub-->
            <!--<div class="menu-sub menu-sub-dropdown w-175px py-4">-->
                <!--begin::Menu item-->
                <!--<div class="menu-item px-3">
                    <router-link to="/pages/profile/overview" class="menu-link px-5">
                        Referrals
                    </router-link>
                </div>-->
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <!--<div class="menu-item px-3">
                    <router-link to="/pages/profile/overview" class="menu-link px-5">
                        Billing
                    </router-link>
                </div>-->
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <!--<div class="menu-item px-3">
                    <router-link to="/pages/profile/overview" class="menu-link px-5">
                        Payments
                    </router-link>
                </div>-->
                <!--end::Menu item-->
                <!--begin::Menu item-->
                <!--<div class="menu-item px-3">
                    <router-link to="/pages/profile/overview"
                                 class="menu-link d-flex flex-stack px-5">
                        Statements

                        <i class="fas fa-exclamation-circle ms-2 fs-7"
                           data-bs-toggle="tooltip"
                           title="View your statements"></i>
                    </router-link>
                </div>-->
                <!--end::Menu item-->
                <!--begin::Menu separator-->
                <!--<div class="separator my-2"></div>-->
                <!--end::Menu separator-->
                <!--begin::Menu item-->
                <!--<div class="menu-item px-3">
                    <div class="menu-content px-3">
                        <label class="form-check form-switch form-check-custom form-check-solid">
                            <input class="form-check-input w-30px h-20px"
                                   type="checkbox"
                                   value="1"
                                   checked
                                   name="notifications" />
                            <span class="form-check-label text-muted fs-7">
                                Notifications
                            </span>
                        </label>
                    </div>
                </div>-->
                <!--end::Menu item-->
            <!--</div>-->
            <!--end::Menu sub-->
        <!--</div>-->
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <!--<div class="menu-item px-5">
            <router-link to="/pages/profile/overview" class="menu-link px-5">
                My Statements
            </router-link>
        </div>-->
        <!--end::Menu item-->
        <!--begin::Menu separator-->
        <!--<div class="separator my-2"></div>-->
        <!--end::Menu separator-->
        <!--begin::Menu item-->
        <div class="menu-item px-5 my-1">
            <router-link to="/account/settings" class="menu-link px-5">
                Cài đặt tài khoản
            </router-link>
        </div>
        <!--end::Menu item-->
        <!--begin::Menu item-->
        <div class="menu-item px-5">
            <a @click="signOut()" class="menu-link px-5"> Thoát </a>
        </div>
        <!--end::Menu item-->
    </div>
    <!--end::Menu-->
</template>

<script lang="ts">
    import { getAssetPath } from "@/core/helpers/assets";
    import { computed, defineComponent } from "vue";
    import { useI18n } from "vue-i18n";
    import { useRouter } from "vue-router";

    export default defineComponent({
        name: "kt-user-menu",
        components: {},
        setup() {
            const router = useRouter();
            const i18n = useI18n();
            const authStore = useAuthStore();
            const user = authStore.user;
            i18n.locale.value = localStorage.getItem("lang")
                ? (localStorage.getItem("lang") as string)
                : "en";

            const countries = {
                en: {
                    flag: getAssetPath("media/flags/united-states.svg"),
                    name: "English",
                },
                es: {
                    flag: getAssetPath("media/flags/spain.svg"),
                    name: "Spanish",
                },
                de: {
                    flag: getAssetPath("media/flags/germany.svg"),
                    name: "German",
                },
                ja: {
                    flag: getAssetPath("media/flags/japan.svg"),
                    name: "Japanese",
                },
                fr: {
                    flag: getAssetPath("media/flags/france.svg"),
                    name: "French",
                },
            };

            const signOut = () => {
                authStore.logout();
                router.push('/account/login');
            };

            const setLang = (lang: string) => {
                localStorage.setItem("lang", lang);
                i18n.locale.value = lang;
            };

            const currentLanguage = computed(() => {
                return i18n.locale.value;
            });

            const currentLangugeLocale = computed(() => {
                return countries[i18n.locale.value as keyof typeof countries];
            });

            return {
                user,
                signOut,
                setLang,
                currentLanguage,
                currentLangugeLocale,
                countries,
                getAssetPath,
            };
        },
    });
</script>
